export default __webpack_public_path__ + "static/media/stats_pageviews.e8bc673e.svg";